module.exports = __webpack_public_path__ + "img/feedback.287962fc.svg";